var _metadata, _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 75.445999,
    viewBox: "0 0 100 75.446",
    id: "Layer_1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata3055"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3053"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3041"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 19.198,44.002 v -8.201 h -8.575 c -3.319,0 -6.021,-2.874 -6.021,-6.406 V 10.903 c 0,-3.533 2.701,-6.408 6.021,-6.408 h 38.345 c 3.319,0 6.019,2.875 6.019,6.408 v 18.492 c 0,3.532 -2.7,6.406 -6.019,6.406 v 4.496 c 5.797,0 10.514,-4.891 10.514,-10.902 V 10.903 C 59.482,4.892 54.766,0 48.968,0 H 10.623 C 4.824,0 0.107,4.892 0.107,10.903 v 18.492 c 0,6.011 4.717,10.902 10.516,10.902 h 4.08 v 7.968 c 0,1.223 0.789,2.332 1.963,2.764 0.334,0.123 0.677,0.184 1.014,0.184 0.821,0 1.609,-0.354 2.165,-1.01 l 8.369,-9.905 h 8.353 V 35.802 H 26.128 l -6.93,8.2 z",
    id: "path3043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 89.377,24.233 h -25.96 v 4.496 h 25.96 c 3.319,0 6.021,2.875 6.021,6.408 v 18.489 c 0,3.533 -2.701,6.408 -6.021,6.408 h -8.574 v 8.205 L 73.872,60.036 H 51.031 c -3.318,0 -6.019,-2.875 -6.019,-6.408 V 35.137 c 0,-3.533 2.701,-6.408 6.019,-6.408 v -4.496 c -5.797,0 -10.515,4.892 -10.515,10.903 v 18.491 c 0,6.014 4.717,10.904 10.515,10.904 h 20.754 l 8.372,9.91 c 0.555,0.652 1.342,1.004 2.161,1.004 0.337,0 0.68,-0.059 1.014,-0.182 1.176,-0.432 1.967,-1.543 1.967,-2.768 V 64.53 h 4.078 c 5.799,0 10.516,-4.891 10.516,-10.904 V 35.137 c 0,-6.012 -4.717,-10.904 -10.516,-10.904 z",
    id: "path3045"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 31.926057,25.021427 1.364106,4.177574 4.376505,0 -7.161554,-20.7173542 -4.717532,0 -7.360487,20.7173542 4.348087,0 1.392524,-4.177574 7.758351,0 m -1.165173,-3.552358 -5.399585,0 2.699792,-8.099377 2.699793,8.099377",
    id: "path3113",
    style: {
      fontSize: "28.41886711px",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      textAlign: "start",
      lineHeight: "125%",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      fontFamily: "Nimbus Sans L",
      InkscapeFontSpecification: "Nimbus Sans L Bold"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 74.882358,52.840053 1.364106,4.177574 4.376505,0 -7.161554,-20.717354 -4.717532,0 -7.360487,20.717354 4.348087,0 1.392525,-4.177574 7.75835,0 m -1.165173,-3.552358 -5.399585,0 2.699792,-8.099377 2.699793,8.099377 M 71.017392,30.048122 c -1.44936,0 -2.586116,1.136756 -2.586116,2.557698 0,1.420942 1.136756,2.557698 2.557698,2.557698 1.392523,0 2.557698,-1.136756 2.557698,-2.529279 0,-1.449361 -1.108338,-2.586117 -2.52928,-2.586117 m 0,1.364106 c 0.653634,0 1.165174,0.539959 1.165174,1.193592 0,0.653634 -0.539959,1.193593 -1.165174,1.193593 -0.682052,0 -1.222011,-0.539959 -1.222011,-1.193593 0,-0.653633 0.539959,-1.193592 1.222011,-1.193592",
    id: "path3115",
    style: {
      fontSize: "28.41886711px",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      textAlign: "start",
      lineHeight: "125%",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      fontFamily: "Nimbus Sans L",
      InkscapeFontSpecification: "Nimbus Sans L Bold"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.7bc66d86960adb1ad1b7b87f3820f836.svg";
export { ForwardRef as ReactComponent };